import { URI } from '~/types/adamTypes';
import type { NomadDB } from '~/db/NomadDB';

export const getExportProgressionsPromises = async (
  db: NomadDB,
  nomadFetch: Function,
  multiProgressionLimit: number = 3500
): Promise<void> => {
  let progressions = await db.progressions.where({ local: 1 }).toArray();

  progressions = progressions.map((progression) => {
    const pr = { ...progression };
    delete pr.local;
    return pr;
  });

  const chunkSize = multiProgressionLimit;

  const chunks = [];

  for (let i = 0; i < progressions.length; i += chunkSize) {
    chunks.push(progressions.slice(i, i + chunkSize));
  }

  const getChunksPromise = async (chunk): Promise<void> => {
    await nomadFetch(URI.MultiProgressions, {
      method: 'POST',
      body: chunk,
    });
    const contentIds = chunk.map((c) => c.contentId);
    await db.progressions
      .where('contentId')
      .anyOf(contentIds)
      .modify({ local: 0 });
  };

  const getPromises = (): Promise<void>[] => {
    const promises = [];
    chunks.forEach((chunk) => {
      promises.push(getChunksPromise(chunk));
    });
    return promises;
  };

  const promises = getPromises();
  if (promises.length) {
    await Promise.all(promises);
  }
};
